/**
 * Sync the user store's selectedBusinessId to whatever business is in the URL,
 * for routes under /business/[businessId]/*. Defense-in-depth — the backend
 * still 404s any request whose business_id doesn't belong to the staff's
 * account, but keeping selectedBusinessId in sync prevents the UI from
 * mixing one business's data with another's URL.
 *
 * If you need stricter enforcement (e.g. block navigation entirely if the
 * URL business isn't in the user's accessible list), the user profile
 * doesn't currently carry that list — it's fetched lazily by BusinessSelector.
 * Switching the strategy would require eagerly loading and caching that list.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.prerender) {
    return
  }

  const raw = to.params?.businessId
  if (!raw) return

  const businessId = Number(raw)
  if (!businessId || Number.isNaN(businessId)) return

  const userStore = useUserStore()
  if (!userStore.isAuthenticated) {
    // auth middleware handles redirect
    return
  }

  if (userStore.selectedBusinessId !== businessId) {
    console.log(
      `businessOwnership: syncing selectedBusinessId ${userStore.selectedBusinessId} → ${businessId} from URL`
    )
    userStore.setSelectedBusiness(businessId)
  }
})
